import { DisplayLink, DisplayButton } from '@xo-union/tk-ui-links';
import { H2 } from '@xo-union/tk-ui-typography';
import React from 'react';

import styles from './disabledWebsite.scss';
import { ReactComponent as DisabledWebsiteImage } from './disabledWebsiteImage.svg';

interface Props {
  showReactivateLink?: boolean;
  reactivateWebsiteCallback?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DisabledSite: React.FC<Props> = ({ showReactivateLink = false, reactivateWebsiteCallback }) => {
  return (
    <div data-testid="disabled-website" className={styles.disableWebsiteContainer}>
      <DisabledWebsiteImage className={styles.image} />
      <div className={styles.infoContainer}>
        <H2>Oops! It looks like your Wedding Website is currently deactivated.</H2>
        <div className={styles.helpText}>
          Reactivating will republish your site and allow you to make changes. Questions? Reach out to{' '}
          <DisplayLink href="mailto:help@theknot.com">help@theknot.com</DisplayLink>
        </div>
        {showReactivateLink && reactivateWebsiteCallback && (
          <DisplayButton onClick={reactivateWebsiteCallback}> Reactivate Now </DisplayButton>
        )}
      </div>
    </div>
  );
};

export default DisabledSite;
